
window.addEventListener('DOMContentLoaded', (event) => {

  // === Custom SEO popup and sidepage

  const customSeoElements = document.querySelectorAll('[data-custom-seo]');
  const customSeoToggles = document.querySelectorAll('[data-custom-seo-toggle]');

  if (customSeoElements.length > 0 && customSeoToggles.length > 0) {

    customSeoToggles.forEach(customSeoToggle => {

      customSeoToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const customSeoKey = customSeoToggle.getAttribute('data-custom-seo-toggle');
        if (customSeoKey !== null && customSeoKey !== undefined) {

          const this_customSeo = document.querySelector(`[data-custom-seo="${customSeoKey}"]`);
          if (this_customSeo !== null && this_customSeo !== undefined) {
            this_customSeo.classList.toggle('active');
            setBodyOverflow();
          }
          
        }

      });
      
    });

    function setBodyOverflow() {

      let customSeoIsOpen = false;

      customSeoElements.forEach(customSeoElement => {

        if (customSeoElement.classList.contains('active')) {
          customSeoIsOpen = true;
        }

      });

      if (customSeoIsOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    
    }
    
  }

});
